import * as React from 'react';
import { ReactElement } from 'react';
interface IWrapperProps {
  children: ReactElement;
}
const Wrapper = ({ children }: IWrapperProps) => <div>{children}</div>;
export default Wrapper;
